import { Component, OnInit, ViewChild, TemplateRef, Input } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { EntitaAnagrafeVO } from "@app/shared/vo/gescor/entita-anagrafeVO";
import { env } from "process";
import { Router } from "@angular/router";

@Component({
  selector: "app-modale-provvisori",
  templateUrl: "./modale-provvisori.component.html",
})
export class ModaleProvvisoriComponent implements OnInit {
  @ViewChild("templateModaleProvvisori", {static: false})
  public provvisoriModal: TemplateRef<any>;
  public modalRef: BsModalRef;
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true
  };
  messages = {
    emptyMessage: "Nessun soggetto trovato",
    totalMessage: "in totale"
  };
  @Input()
  rowsAnagrafeProvvisori: EntitaAnagrafeVO[] = new Array<EntitaAnagrafeVO>();
  private urlAnagrafeDettaglioProvvisori = env.URL_ANAGRAFE_DETTAGLIO_PROVVISORIO;
  constructor(private modalService: BsModalService, private router: Router) { }

  ngOnInit() {
  }

  openModal() {
    this.modalRef = this.modalService.show(this.provvisoriModal, this.config);

  }

  vaiASoggetto(row: EntitaAnagrafeVO) {
    window.open(this.urlAnagrafeDettaglioProvvisori + row.idSoggetto + "&redirect=true", "_blank");
  }

}

